import Vue from "vue";
export default Vue.extend({
    name: "Home",
    methods: {
        selectPlayer(selectedPlayer) {
            this.$router.push({
                path: "/play",
                query: { player: `${selectedPlayer}` }
            });
        }
    },
    mounted() {
        document.title = this.$route.name || "すごろーく";
        this.$gtag.pageview({
            // eslint-disable-next-line @typescript-eslint/camelcase
            page_path: this.$route.path,
            // eslint-disable-next-line @typescript-eslint/camelcase
            page_title: this.$route.name || undefined
        });
    }
});
